/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2021-01-06 14:05:44
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-26 18:41:47
 */
import React, { } from 'react'
import { Input, message } from 'antd';
// import './index.css'
import moreimg from '../../../../resources/img/icon-more (3).png'
// import { UserOutlined, SearchOutlined } from '@ant-design/icons';
import { DeleteRoomUnReadMsg } from '../../../../store/actionCreators'
// import { AddRoomMessage } from '../../../store/actionCreators'
// import store from '../../../store'
import { connect } from 'react-redux'
import CustomModal from '../../../components/CustomModal/index';
import { sendmessagepublic, sendmessageprivate } from '../../../../service/loginaction';
import ChatInfo from './RoomInfoWindow';
import HistoryWindow from './HistoryWindow';
import AddGroupMumber from './AddGroupMumber';
// import { getDownloadPathLocal } from '../../../service/localstore';
import { customlog } from '../../../../utils/tools';
import MessageEntity from './MessageEntity';
import { sendFile } from '../service/action';

var fs = window.fs;
const { Search, TextArea } = Input
const ipcRenderer = window.electron ? window.electron.ipcRenderer : null;
let lastMessage = {};
let firstMessage = -1;

class ChatView extends React.Component {
    state = {
        loading: true,
        messageList: [],
        showSize: 30,
        hasmore: true, //还有历史消息未在视图中显示
        scrollbottom: 0,
        textAreaValue: '',
        emojiValue: '',
        groupMumberList: [],//群组成员
    }

    async componentDidMount() {
        this.setState({ roomId: this.props.activeRoom.roomId })
        this.reload(this.props.activeRoom.roomId)
        this.chatinfopanel.load(this.props.activeRoom)
    }

    async shouldComponentUpdate(nextProps, nextState) {
        // customlog("shouldComponentUpdate");
        let roomInfo = nextProps.activeRoom
        let lastRoomInfo = this.props.activeRoom

        //切换了房间
        if (roomInfo.roomId !== lastRoomInfo.roomId) {
            console.log("切换了房间" + lastRoomInfo.roomId + '--->' + roomInfo.roomId);
            this.setState({ roomId: roomInfo.roomId, loading: true, showSize: 30, hasmore: false })
            this.chatinfopanel.load(roomInfo)
            await this.reload(roomInfo.roomId)
            // this.message.focus()
            return true
        }
        let roomMess = (nextProps.messageList)[roomInfo.roomId] || []
        let lastRoomMess = (this.props.messageList)[roomInfo.roomId] || []
        //当前房间来新消息了
        if (roomMess.length - lastRoomMess.length > 0) {
            // this.props.deleteRoomUnReadMsg({ roomId: this.state.roomId })
            // console.log("当前房间加载新消息了 ");
            let dd = ((nextProps.messageList)[roomInfo.roomId])      //千万不要直接修改nextprops！！！！！找了我半天bug   ,  不是改nextprops的问题 ，是不能用  shift（）改数据对象，会把源对象改了
            const mess = dd[dd.length - 1]
            if (!mess.messageId) {//消息还在发送中的状态，还没有id
            } else if (mess.messageId !== lastMessage.messageId) {
                lastMessage.type = mess.type
                lastMessage.content = mess.content
                lastMessage.messageId = mess.messageId
                // let message = [];
                // message.push(mess);
                // await this.addMessage(message);
                this.addMessage(dd)
            }
            return true
        }
        if (nextState.messageList.length > this.state.messageList.length) {
            // console.log("更新视图，添加message");
        }
        if (nextProps !== this.props) {
            // console.log("props改变了");
        }
        if (nextState !== this.state) {
            // console.log("state 改变了");
        }
        return true
    }

    scroll() {
        // // let scr = document.getElementsByClassName('message-content-scroll')[0]
        // var scrollTop = this.chatviewScroll.scrollTop;    //滚动条距离顶部的高度
        // var scrollHeight = this.chatviewScroll.scrollHeight;   //当前页面的总高度
        // var clientHeight = this.chatviewScroll.clientHeight;    //当前可视的页面高度
        // console.log("top:" + scrollTop + ",doc:" + scrollHeight + ",client:" + clientHeight);
        // // if (scrollTop + clientHeight >= scrollHeight) {   //距离顶部+当前高度 >=文档总高度 即代表滑动到底部 count++;         //每次滑动count加1
        // //     filterData(serviceTypeId, industryId, cityId, count); //调用筛选方法，count为当前分页数
        // // else if(scrollTop<=0){ 
        // //滚动条距离顶部的高度小于等于0 TODO
        // //alert("下拉刷新，要在这调用啥方法？");
        // // }
        // let marginbottom = scrollHeight - scrollTop
        // this.setState({ scrollbottom: marginbottom })
    }

    handleTextAreaChange = (e) => {
        this.setState({
            textAreaValue: e.target.value
        })
    }
    /**
     * 切换聊天窗 时  重新加载页面聊天历史数据
     */
    reload = (roomId) => {
        return new Promise((resolve, reject) => {
            let messageList = this.props.messageList[roomId] || []
            // this.message && this.message.val(null)
            this.setState({
                textAreaValue: ''
            })
            if (messageList.length > 0) {
                lastMessage.messageId = messageList[messageList.length - 1].messageId
            }
            console.log("messageList", messageList);
            if (messageList.length >= this.state.showSize) {
                this.setState({ hasmore: true })
            } else {
                this.setState({ hasmore: false })
            }
            this.setState({ messageList: messageList.slice(-this.state.showSize) }, () => {
                setTimeout(() => {
                    customlog('滚动到最底部')
                    document.getElementById('msg_end').scrollIntoView()
                    this.setState({ loading: false })
                }, 100)
            })
            resolve()

        })
    }
    loadhistory = () => {
        var scrollTop = this.chatviewScroll.scrollTop;    //滚动条距离顶部的高度
        var scrollHeight = this.chatviewScroll.scrollHeight;   //当前页面的总高度
        let marginbottom = scrollHeight - scrollTop
        console.log("this.props.activeRoom.roomId:", this.props.activeRoom.roomId, "this.props.messageList:", this.props.messageList)

        let messageList = this.props.messageList[this.props.activeRoom.roomId] || []
        if (messageList.length >= this.state.showSize + 30) {
            this.setState({ hasmore: true })
        } else {
            this.setState({ hasmore: false })
        }
        this.setState({ showSize: this.state.showSize + 30, historyloading: true })
        this.setState({ messageList: messageList.slice(-this.state.showSize - 30), historyloading: false })
        setTimeout(() => {
            this.chatviewScroll.scrollTop = this.chatviewScroll.scrollHeight - marginbottom
        }, 200)
    }
    //把消息加入到消息视图中
    addMessage = async (messList, insert = false) => {
        // var { messageList } = this.state
        // let messageList = this.props.messageList[this.props.activeRoom.roomId] || []
        // for (let i = 0; i < messList.length; i++) {
        // let item = messList[i]
        // item.status = "send_succeed"
        // messageList.push(item)
        if (messList.length >= this.state.showSize) {
            this.setState({ hasmore: true })
        } else {
            this.setState({ hasmore: false })
        }
        this.setState({ messageList: messList.slice(-this.state.showSize) }, () => {
            // setTimeout(() => {
            console.log('滚动到最底部')
            document.getElementById('msg_end').scrollIntoView()
            // }, 100)
        })

        // }
    }

    //点击发消息  发送文字消息
    // ********  **********  ********  *******
    // ***  *     ***        *  ****   *******
    // **      *  ****  *       **         ***
    // **           *******  *****         ***
    // *****  ******            **   ****  ***
    // ****        ***     ***  **         ***
    // ****   **  **** *        **         ***
    // ***        ****     ***  ***     ** ***
    // **   *    ****           *       *   **
    // *   **    ****  *   ***  *     **     *
    // ***    *        *   **   * **      ****
    onSendMessage = (e) => {
        if (e.shiftKey) {
            return
        }
        e.preventDefault()
        // var messagebox = this.message
        // let messagevalue = messagebox.state.value
        // messagebox.val(null)
        var messagebox = this.state.textAreaValue
        let messagevalue = messagebox
        this.setState({
            textAreaValue: ''
        })
        // document.getElementById('chatview-textarea').innerHTML = ''
        // }, 10);
        if (!messagevalue) {
            message.warning({
                content: '发送消息不能为空',
                // className: 'custom-class',
                style: {
                    marginTop: '80vh',
                    marginLeft: '200px',
                },
                duration: 0.5
            })
            return
        }
        //群聊
        if (this.props.activeRoom.type === 'public') {
            console.log(this.state.roomId)
            sendmessagepublic({ url: this.state.roomId, content: messagevalue, type: 'text' })
        }
        // 私聊 
        else if (this.props.activeRoom.type === 'private') {
            sendmessageprivate({ targetuserId: this.state.roomId.substring(9), content: messagevalue, type: 'text' })

        }
        // dispatchmessage({
        //     content: messagevalue,
        //     type: 'text',
        //     roomId: this.state.roomId,
        //     userId: this.props.user.userId,
        //     lock: true
        // })
    }

    /**发文件 */
    onSendFile = (file, type) => {
        sendFile(this.state.roomId, file, type)
    }
    /**点击 图片选择 */
    selectImg = () => {
        document.getElementById("chatview-imgupload").click()
    }
    selectFile = () => {
        document.getElementById("chatview-fileupload").click()
    }
    //发图片
    selectFliep = (file) => {
        var _this = this
        file = file.target
        if (!file.files || !file.files[0]) {
            return;
        }
        this.onSendFile(file.files[0], 'img')
    }
    // 发文件
    selectFlie = (file) => {
        var _this = this
        file = file.target
        if (!file.files || !file.files[0]) {
            return;
        }
        this.onSendFile(file.files[0], 'file')
    }
    openImgViewer = () => {
        this.emoji.show()
    }
    onSelectTextArea = (e) => {
        // console.log(e)
        //    let b= document.getElementById('chatview-textarea')
        //     message213.setCaret(b);
    }
    // 显示对话详细信息    右上角...
    showMore = () => {
        this.chatinfo.show()
    }
    showAddGroupMumberPanel = () => {
        this.addGroupMumber.show()
    }

    getGroupmumberList = (mumberList) => {
        // console.log(mumberList)
        this.setState({
            groupMumberList: mumberList
        })
    }

    reloadTheGroupMumberList = () => {
        console.log("reloadTheGroupMumberListreloadTheGroupMumberListreloadTheGroupMumberList")
        this.chatinfopanel.load(this.props.activeRoom)
    }

    render() {
        // console.log("render————————————————————————————————————————————————")
        const { previewVisible, previewImage, fileList, previewTitle } = this.state;
        // console.log("this.state.messageList:",this.state.messageList)
        return (
            <div className='chatview-main'>
                {/* 对话名称 */}
                {/* <div style={{ width: 1143, background: 'white', height: 48, lineHeight: '48px', paddingLeft: 40, fontSize: 16, color: 'rgba(0, 0, 0, 0.65)' }}                          >
                    {this.props.activeRoom.chatName}
                    <img src={moreimg} onClick={this.showMore} style={{ float: 'right', cursor: 'pointer', marginRight: 16 }}></img>
                </div> */}
                <div className="chat_view_content">
                    <div className='chat-content-title'> {
                        this.props.activeRoom.type === 'public' ?
                            this.props.newGroupList.find((item) => {
                                return item.roomId === this.props.activeRoom.roomId
                            }).chatName : this.props.activeRoom.chatName
                    }
                        <img src={moreimg} onClick={this.showMore}
                            style={{ float: 'right', cursor: 'pointer', marginRight: 20, marginTop: 4 }} alt={""}></img>
                    </div>
                    {/* 对话内容 */}
                    <div className='message-content-scroll-panel'>
                        <div className='message-content-scroll' onScroll={this.scroll.bind(this)}
                            ref={ref => {
                                this.chatviewScroll = ref
                            }}>
                            {/*<div className='message-content-hasmore' style={{opacity: this.state.loading ? 0 : 1}}*/}
                            {/*     onClick={this.loadhistory}>加载更多</div>*/}
                            {this.state.hasmore &&
                                <div className='message-content-hasmore' style={{ opacity: this.state.loading ? 0 : 1 }}
                                    onClick={this.loadhistory}>加载更多</div>}
                            <div style={{ opacity: this.state.loading ? 0 : 1 }}>
                                {
                                    this.state.messageList.length > 0 && this.state.messageList.map((data, index) =>
                                        <MessageEntity key={data.messageId} data={data}
                                            userinfo={this.props.usercacheList[data.userId]}
                                            user={this.props.user} />
                                    )
                                }
                            </div>
                            <div id='msg_end' style={{ width: '100%', height: 20, float: 'left' }}></div>
                        </div>
                    </div>
                    {/* 发送 */}
                    <div className="chatview-send-warp">
                        <div className='chatview-send-tool-panel'>
                            <input type="file" accept="/*" id='chatview-fileupload' onChange={this.selectFlie}>
                            </input>
                            <input type="file" accept="image/*" id='chatview-imgupload' onChange={this.selectFliep}>
                            </input>
                            <img alt='' src={require('../../../../resources/img/icon-emoji.png')}
                                className='chatview-send-tool-img' onClick={this.openImgViewer}></img>
                            <img alt='' src={require('../../../../resources/img/icon-image-hover.png')}
                                className='chatview-send-tool-img' onClick={this.selectImg}></img>
                            <img alt='' src={require('../../../../resources/img/icon-fileFolder-hover.png')}
                                className='chatview-send-tool-img' onClick={this.selectFile}></img>
                            <img alt='' src={require('../../../../resources/img/icon-historicalRecord-hover.png')}
                                className='chatview-send-tool-img' onClick={() => {
                                    this.historypanel.show()
                                    this.historywindow.setbottom()
                                }}></img>
                        </div>
                        <TextArea bordered={false} className='chatview-send-textarea' id='chatview-textarea'
                            // onChange={this.onMseageChange} value={this.state.message}
                            // autoSize={{ minRows: 5 }}
                            onSelect={this.onSelectTextArea}
                            onClick={this.onSelectTextArea}
                            onKeyUp={this.onSelectTextArea}
                            // ref={(ref) => { this.message = ref }}
                            value={this.state.textAreaValue}
                            onChange={this.handleTextAreaChange}
                            onPressEnter={this.onSendMessage}
                        >
                        </TextArea>
                        <div className='chatview-send-bottom-panel'>
                            <button className='chatview-send-btn'
                                style={this.state.textAreaValue ? { backgroundColor: 'rgb(43, 39, 156)' } : { backgroundColor: 'rgb(213, 213, 213)' }}
                                onClick={this.onSendMessage}>
                                发送
                            </button>
                            {/* <button onClick={this.test}>ceshi</button> */}
                            {/* <a href='http://www.baidu.com' target='_blank'>ceshi</a> */}
                        </div>
                    </div>
                </div>

                <CustomModal className='chat-emoji-panel' backopcity={0.01} backclose ref={(ref) => {
                    this.emoji = ref
                }}>
                    <Emoji
                        close={() => {
                            this.emoji.close()
                        }}
                        setvalue={(str) => {
                            this.setState({ textAreaValue: str })
                        }}
                    // value={this.state.textAreaValue}
                    ></Emoji>
                </CustomModal>
                <CustomModal className='chat-chatinfo-panel' backopcity={0.01} backclose ref={(ref) => {
                    this.chatinfo = ref
                }}>
                    <ChatInfo close={() => {
                        this.chatinfo.close()
                    }} onRef={(ref) => {
                        this.chatinfopanel = ref
                    }}
                        showAddGroupMumberPanel={this.showAddGroupMumberPanel}
                        getGroupmumberList={(mumberList) => this.getGroupmumberList(mumberList)}
                    ></ChatInfo>
                </CustomModal>
                <CustomModal className='chat-history-panel' backopcity={0.01} backclose ref={(ref) => {
                    this.historypanel = ref
                }}>
                    <HistoryWindow close={() => {
                        this.historypanel.close()
                    }} onRef={(ref) => {
                        this.historywindow = ref
                    }}></HistoryWindow>
                </CustomModal>
                <CustomModal className='chat-add-group-mumber-panel' backopcity={0.01} ref={(ref) => {
                    this.addGroupMumber = ref
                }}>
                    <AddGroupMumber
                        close={() => {
                            this.addGroupMumber.close()
                        }}
                        // onRef={(ref) => {
                        //     this.addGroupMumberPanel = ref
                        // }}
                        groupMumberList={this.state.groupMumberList}
                        reloadTheGroupMumberList={() => this.reloadTheGroupMumberList()}
                    >
                    </AddGroupMumber>
                </CustomModal>
            </div>
        )
    }
}


// 😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😡😡😡😂😂😡😡😡😂
// 😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😡😡😡😂😂😡😡😡😂
// 😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂
// 😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂
// 😂😂😡😡😡😡😡😡😡😂😡😡😡😡😡😡😡😡😡😡😡😂😂😡😡😡😡😡😡😂😂😂😂😡😡😡😂😂😡😡😡😂
// 😂😡😡😡😡😂😡😡😡😂😡😡😡😡😡😡😡😡😡😡😡😂😡😡😡😂😡😡😡😡😂😂😂😡😡😡😂😂😡😡😡😂
// 😂😡😡😡😂😂😂😡😡😡😡😡😡😂😡😡😡😂😡😡😡😡😡😡😡😂😂😡😡😡😡😂😂😡😡😡😂😂😡😡😡😂
// 😡😡😡😡😡😡😡😡😡😡😡😡😡😂😡😡😡😂😡😡😡😡😡😡😂😂😂😂😡😡😡😂😂😡😡😡😂😂😡😡😡😂
// 😡😡😡😡😂😂😂😂😂😂😡😡😡😂😡😡😡😂😡😡😡😡😡😡😂😂😂😂😡😡😡😂😂😡😡😡😂😂😡😡😡😂
// 😡😡😡😡😂😂😂😂😂😂😡😡😡😂😡😡😡😂😡😡😡😡😡😡😂😂😂😂😡😡😡😂😂😡😡😡😂😂😡😡😡😂
// 😂😡😡😡😂😂😡😡😡😡😡😡😡😂😡😡😡😂😡😡😡😡😡😡😡😂😂😡😡😡😂😂😂😡😡😡😂😂😡😡😡😂
// 😂😂😡😡😡😡😡😡😡😂😡😡😡😂😡😡😡😂😡😡😡😂😡😡😡😡😡😡😡😡😂😂😂😡😡😡😂😂😡😡😡😂
// 😂😂😂😡😡😡😡😡😂😂😡😡😡😂😡😡😡😂😡😡😡😂😂😂😡😡😡😡😂😂😂😂😂😡😡😡😂😂😡😡😡😂
// 😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😡😡😡😂😂😂😂😂😂
// 😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😂😡😡😡😡😡😂😂😂😂😂😂

const Emoji = (props) => {
    // state = {
    //     emojiValue : ""
    // }
    const emoji = [{
        groupname: '',
        group: ['😀', '😃', '😄', '😁', '😆', '😅', '😂', '🤣', '😇', '😉', '😊',
            '🙂', '🙃', '☺', '😋', '😌', '😍', '🥰', '😘', '😗', '😙', '😚', '🤪', '😜',
            '😝', '😛', '🤑', '😎', '🤓', '🧐', '🤠', '🥳', '🤗', '🤡', '😏', '😶', '😐',
            '😑', '😒', '🙄', '🤨', '🤔', '🤫', '🤭', '🤥', '😳', '😞', '😟', '😠', '😡',
            '🤬', '😔', '😕', '🙁', '☹', '😬', '🥺', '😣', '😖', '😫', '😩', '🥱', '😤',
            '😮', '😱', '😨', '😰', '😯', '😦', '😧', '😢', '😥', '😪', '🤤', '😓', '😭',
            '🤩', '😵', '🥴', '😲', '🤯', '🤐', '😷', '🤕', '🤒', '🤮', '🤢', '🤧', '🥵',
            '🥶', '😴', '💤', '😈', '👿', '👹', '👺']
    }]


    // console.log('😡😡😡😡😡😂😡😡😡😂'.split(''));
    function insertemoji(char) {
        var textarea = document.getElementById('chatview-textarea')
        var textareaStr = textarea.value;
        var start = textarea.selectionStart
        var end = textarea.selectionEnd
        if (!textareaStr) textareaStr = ''
        let str = textareaStr.substring(0, start) + char + textareaStr.substring(end)
        props.setvalue(str)

        // props.close()
        textarea.focus()
        // textarea.selectionStart=start
    }

    return (<div className='chat-emoji-back'>
        {
            emoji[0].group.map((char, index) => {
                return (<div className='emoji' key={index} style={{ float: 'left', cursor: 'pointer' }}
                    onClick={insertemoji.bind(this, char)}>{char}</div>)
            })
        }
    </div>)
}


function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });
}

const mapState = state => ({
    user: state.userReducer.get('user').toJS(),
    messageList: state.messageReducer.get('messageList').toJS(),
    usercacheList: state.cacheReducer.get('usercacheList').toJS(),
    activeRoom: state.userReducer.get('activeRoom'),
    newGroupList: state.userReducer.get('newGroupList').toJS()

})

const mapDispatch = dispatch => ({
    // addRoomLastMsg(param) {
    //     dispatch(AddRoomLastMsg(param))
    // },
    deleteRoomUnReadMsg(param) {
        dispatch(DeleteRoomUnReadMsg(param))
    }
})

export default connect(
    mapState,
    mapDispatch
)(ChatView)

